<div>
    <!-- *ngIf="proof_url?.length" -->
    <div class="tab-bg-view">
        <h6 class="font-600">{{"Attendance prove" | translator}}</h6>
        <div class="row">
            <div *ngFor="let proof_url of proof_url" class="col-md-6 col-12 d-flex align-items-center">
                <!-- <img class="border-white" *ngIf="checkisImg(proof_url?.url); else elseBlock" [src]="staticURL+proof_url?.url"
        class="img-fluid p-1 tab-img" alt="image not found">
        <ng-template #elseBlock>
            <video  class="w-100 my-3 border-white" width="640" height="360" controls>
                <source [src]="staticURL+proof_url?.url" type="video/mp4">
               {{"Your browser does not support this type of video"| translator}}
            </video>
        </ng-template> -->
                <app-main-view [url]="staticURL+proof_url?.url" [courseId]="courseId" [viewData]="{}"
                    [attendanceView]="true"></app-main-view>
            </div>
        </div>
        <div class="w-100 my-4" *ngIf="!sessionAtt?.historyView?.view">
            <h6 class="font-600">{{"Upload attendance prove" | translator}}</h6>
            <input class="form-control" type="file" id="formFile" (input)="addFiles($event)"
                accept=".jpg,.jpeg,.png,.mp4,.pdf,.doc,.docx,.txt,.pptx,.ppt,.xlsx,.xls,video/*">
        </div>
        <div class="w-100 mt-2" *ngIf="fileProgress">
            <p-progressBar [value]="uploadProgress"></p-progressBar>
        </div>
    </div>
</div>

<p-table [value]="attendees" dataKey="_id" [paginator]="true" [rows]="10" [selectionPageOnly]="true"
    [tableStyle]="{'min-width': '50rem','margin':'2rem 0rem'}">
    <ng-template pTemplate="header">
        <tr>

            <th style="min-width:200px">{{"user name" | translator}}</th>
            <th style="min-width:200px">{{"Attendance" | translator}}</th>

        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>

            <td>{{product.name.first +' ' + product.name.middle + ' ' +
                product.name.last}}</td>

            <td>
                <p-checkbox *ngIf="!sessionAtt?.historyView?.view" [(ngModel)]="product.attend" class="shadow"
                    [binary]="true" inputId="binary" (onChange)="change(product._id,product.attend)"></p-checkbox>
                <span *ngIf="sessionAtt?.historyView?.view">{{ (product.attend ? 'Present' : 'Absent') | translator}}
                </span>

            </td>
        </tr>
    </ng-template>
</p-table>

<div *ngIf="!sessionAtt?.historyView?.view" class="d-flex justify-content-center">
    <button type="button" (click)="saveAttendees()"
     class="mb-ten my-3 py-2 v4-btn-every"><i class="pi pi-user-edit v4-ml-2"></i>{{"Update" | translator}}</button>
</div>